import TrashIcon from "../../assets/icons/Trash";
import {
  addCartItem,
  deleteCartItem,
  getProductById,
} from "../../services/cartShoppingService";
import { AppDispatch } from "../../store/store";
import { getPrice } from "../../utils/getPrice";
import NumberInput from "../NumberInput/NumberInput";
import "./ShoppingCartItem.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const ShoppingCartItem = ({
  code,
  quantity,
}: {
  code: string;
  quantity: number;
}) => {
  const [product, setProduct] = useState<any>();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (!product && code) {
      getProductById(code).then((res) => setProduct(res));
    }
  }, [code, product]);

  return (
    <div className="shopping-cart-item" key={product?.Code}>
      <div>
        <img src={product?.ImageUrl} alt={product?.Description} />
      </div>
      <div>
        <div>{product?.Designation}</div>
        <div className="cart-item-footer">
          <div>
            {getPrice(product?.PrixHT, product?.TVATaux) * quantity}€ HT
          </div>
          <div>
            <NumberInput
              quantity={quantity}
              add={() =>
                dispatch(
                  addCartItem({
                    productCode: code,
                    quantity: 1,
                  })
                )
              }
              remove={() => dispatch(deleteCartItem({ code, remove: false }))}
            />
            <TrashIcon
              className="clickable"
              onClick={() => dispatch(deleteCartItem({ code, remove: true }))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCartItem;
